import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '../../../general/services/theme.service';
import { ScreenSaverService } from '../../services/screen-saver.service';

@Component({
  selector: 'app-screen-saver',
  templateUrl: './screen-saver.component.html',
  styleUrls: ['./screen-saver.component.css']
})
export class ScreenSaverComponent implements OnInit, OnDestroy {

  private imageIndex: number;
  private slideshowTimer: any;
  private backgroundColor: string;

  constructor(
    private screenSaverService: ScreenSaverService,
    private themeService: ThemeService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    if (!this.screenSaverService.isShow) {
      this.router.navigateByUrl('');
      return;
    }

    if (this.showImages) {
      this.imageIndex = 0;
      this._showNextImage();
    } else {
      if (this.showMessage) {
        this.themeService.setBackgroundCategoryImage(this.themeService.all_category_id);
      } else {
        this.themeService.setBackgroundImage('none');
        this.backgroundColor = this.themeService.backgroundColor;
        this.themeService.backgroundColor = 'black';
      }
    }
  }

  ngOnDestroy() {
    this.themeService.backgroundColor = this.backgroundColor;

    if (this.slideshowTimer != null) {
      clearTimeout(this.slideshowTimer);
      this.slideshowTimer = null;
    }
  }

  _showNextImage() {
    if (!this.showImages) {
      return;
    }

    this.themeService.setBackgroundImageById(this.screenSaverService.configuration.imagesIds[this.imageIndex]);

    if (this.screenSaverService.configuration.imageShowTimeout === 0 || this.screenSaverService.configuration.imagesIds.length < 2) {
      return;
    }

    this.imageIndex++;
    if (this.screenSaverService.configuration.imagesIds.length <= this.imageIndex) {
      this.imageIndex = 0;
    }

    this.slideshowTimer = setTimeout(() => {
      this._showNextImage();
    }, this.screenSaverService.configuration.imageShowTimeout * 1000);
  }

  click() {
    this.screenSaverService.forceStopShow();
  }

  get showMessage(): boolean {
    return this.screenSaverService.configuration && this.screenSaverService.configuration.mode === 'text';
  }

  get showImages(): boolean {
    return this.screenSaverService.configuration
      && this.screenSaverService.configuration.mode === 'images'
      && this.screenSaverService.configuration.imagesIds
      && this.screenSaverService.configuration.imagesIds.length !== 0;
  }

  get message(): string {
    return this.screenSaverService.configuration.message;
  }
}
